import { useBannersStore } from '~/stores/apostatudo/banners';
import { fetchBannersHandler } from '~/handlers/fetch-banners.handler';

export const useBanners = () => {
  const bannersStore = useBannersStore();

  const fetchBanners = async () => {
    bannersStore.loading = true;

    try {
      const result = await fetchBannersHandler();

      bannersStore.setBanners(result);
    } catch (error) {
      console.error('Error in useBanners:', error);
    } finally {
      bannersStore.loading = false;
    }
  };

  return {
    fetchBanners,
    mainBanners: computed(() => bannersStore.mainBanners),
    homeBanners: computed(() => bannersStore.homeBanners),
    loading: computed(() => bannersStore.loading),
    hasMainBanners: computed(() => bannersStore.hasMainBanners),
    hasHomeBanners: computed(() => bannersStore.hasHomeBanners),
  };
};
